import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
	useLocation,
} from "react-router-dom";
import { motion } from "framer-motion";

import Login from "./app/modules/Auth/Login";
import { SSOLogin } from "./app/modules/Auth/sso/sso";
import CreateAccount from "./app/modules/Auth/CreateAccount";
import { RecoveryPassword } from "./app/modules/Auth/recovery-password/recovery-password";

import modules from "./app/modules";
import { UserType } from "./context/userContext/props";
import { Plans } from "./app/modules/base/plans";
import { useEffect } from "react";

const getAuthenticatedUser = () => {
	try {
		let usuario = localStorage.getItem("user-store");
		if (usuario) {
			let auth: UserType = JSON.parse(usuario);
			return auth;
		} else {
			return false;
		}
	} catch (e) {
		return false;
	}
};

const isAuthFn = () => {
	const auth = getAuthenticatedUser();
	if (auth) {
		return auth.token !== "";
	} else {
		return false;
	}
};

const isManager = () => {
	const auth = getAuthenticatedUser();
	if (auth) {
		return auth.profile_status === "Parceiro" || auth.is_superuser;
	} else {
		return false;
	}
};

const isAdmin = () => {
	const auth = getAuthenticatedUser();
	if (auth) {
		return auth.is_superuser;
	} else {
		return false;
	}
};

const HandleRoutes = () => {
	if (
		window.location.pathname !== "/login" &&
		window.location.pathname !== "/sso" &&
		window.location.pathname !== "/create-account" &&
		window.location.pathname !== "/recovery-password" &&
		window.location.pathname !== "/plans"
	) {
		let allRoutes: string[] = [];
		let paramRoutes: string[] = [];
		let publicRoutes: string[] = [
			"/home",
			"/unity",
			"/disciplines",
			"/objects",
		];
		const managerRoutes: string[] = [];
		const adminRoutes: string[] = [
			"/manager/admin/dashboard",
			"/manager/admin/billing",
			"/manager/admin/requests",
			"/manager/admin/request/:id",
		];

		modules.forEach((module) => {
			module.children.forEach((route) => {
				let result = route.indexOf(":");
				if (result !== -1) {
					paramRoutes.push(route);
				} else {
					if (route.includes("manager")) {
						managerRoutes.push(route);
					}
					allRoutes.push(route);
				}
			});
		});

		return modules.map((module: any) => {
			if (allRoutes.includes(window.location.pathname)) {
				if (publicRoutes.includes(window.location.pathname)) {
					return <Route {...module.routeProps} key={module.name} />;
				} else if (adminRoutes.includes(window.location.pathname)) {
					if (!isAdmin()) {
						window.location.href = "/home";
						return null;
					} else {
						return (
							<Route {...module.routeProps} key={module.name} />
						);
					}
				} else if (managerRoutes.includes(window.location.pathname)) {
					if (!isManager()) {
						window.location.href = "/home";
						return null;
					} else {
						return (
							<Route {...module.routeProps} key={module.name} />
						);
					}
				} else {
					if (!isAuthFn()) {
						window.location.href = "/home";
						return null;
					} else {
						return (
							<Route {...module.routeProps} key={module.name} />
						);
					}
				}
			} else {
				let pathSplited = window.location.pathname.split("/");
				let bool = false;

				paramRoutes.forEach((route: any) => {
					let routeSplited = route.split("/");
					let newPath = "";

					routeSplited.forEach((value: string, index: number) => {
						if (index > 0) {
							if (value.indexOf(":") !== -1) {
								newPath += "/" + pathSplited[index];
							} else {
								newPath += "/" + value;
							}
						}
					});

					if (newPath === window.location.pathname) {
						return (bool = true);
					}
				});

				if (bool) {
					return <Route {...module.routeProps} key={module.name} />;
				} else {
					window.location.href = "/home";
					return null;
				}
			}
		});
	}
};

const ScollBackTop = () => {
	const { pathname } = useLocation();

	// scroll page back to top when changing pages
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "auto",
		});
	}, [pathname]);

	return <></>;
};

const Rotas = () => {
	return (
		<motion.div
			initial="initial"
			animate="animate"
			transition={{ duration: 1 }}
			variants={{
				initial: {
					opacity: 0,
				},
				animate: {
					opacity: 1,
				},
			}}
		>
			<Router>
				<ScollBackTop />
				<Switch>
					<Route exact path="/">
						<Redirect to="home" />
					</Route>
					<Route path="/sso" component={SSOLogin} />
					<Route path="/login" component={Login} />
					<Route path="/create-account" component={CreateAccount} />
					<Route
						path="/recovery-password"
						component={RecoveryPassword}
					/>
					<Route path="/plans" component={Plans} exact />
					{HandleRoutes()}
				</Switch>
			</Router>
		</motion.div>
	);
};

export default Rotas;
